export const MODALS = {
    CHANGE_SUBSCRIPTION: 'CHANGE_SUBSCRIPTION',
    INTERNAL_CHANGE_SUBSCRIPTION_DATA: 'INTERNAL_CHANGE_SUBSCRIPTION_DATA',
    CONFIRMATION: 'CONFIRMATION',
    UPDATE_CONSTRAINT: 'UPDATE_CONSTRAINT',
}
